import { css as _css } from "@emotion/core";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { withMedia } from 'react-media-query-hoc';
import { slugify } from '@domain-group/fe-helper';
import { ChevronUpIconSmall, ChevronDownIconSmall, ChevronRightIcon } from '@domain-group/fe-co-icon';
import * as styles from './division-group.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class DivisionGroup extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "toggleDivisions", () => {
      this.setState(prevstate => ({
        isExpanded: !prevstate.isExpanded
      }));
    });
    _defineProperty(this, "renderHeading", () => {
      var desktop = this.props.media.desktop;
      if (desktop) {
        return ___EmotionJSX("h2", null, ___EmotionJSX("a", {
          css: styles.divisionGroupName,
          href: this.props.href,
          "data-testid": "division-group-name"
        }, this.props.name, ___EmotionJSX(ChevronRightIcon, {
          css: styles.divisionGroupNameChevron,
          size: "custom"
        })));
      }
      var Icon = this.state.isExpanded ? ChevronUpIconSmall : ChevronDownIconSmall;
      return ___EmotionJSX("h2", {
        css: styles.divisionGroupName,
        "data-testid": "division-group-name"
      }, ___EmotionJSX("a", {
        css: styles.divisionGroupNameLink,
        href: this.props.href
      }, this.props.name), ___EmotionJSX("div", {
        role: "button",
        css: styles.divisionGroupNameLinkIcon,
        onClick: this.toggleDivisions,
        onKeyDown: () => {},
        disabled: true
      }, ___EmotionJSX(Icon, {
        theme: "allhomes"
      })));
    });
    this.state = {
      isExpanded: false
    };
  }
  render() {
    return ___EmotionJSX("div", {
      css: styles.divisionItem
    }, this.props.name && this.renderHeading(), ___EmotionJSX("div", {
      css: /*#__PURE__*/_css([styles.divisionGroupItems, ...(this.props.divisions.length > 1 ? [styles.divisionGroupItemsMultipleColumn] : []), ...(this.state.isExpanded || !this.props.isCollapsable ? [styles.divisionGroupItemsExpanded] : [])])
    }, this.props.divisions.map(item => ___EmotionJSX("a", {
      key: slugify(item.name || ''),
      css: styles.divisionGroupLink,
      href: item.href,
      onClick: item.onClick,
      "data-testid": "division-group-link"
    }, item.name))));
  }
}
DivisionGroup.propTypes = {
  name: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  divisions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    onClick: PropTypes.func
  })).isRequired,
  media: PropTypes.shape({
    desktop: PropTypes.bool
  }),
  isCollapsable: PropTypes.bool
};
DivisionGroup.defaultProps = {
  media: {},
  isCollapsable: true
};
export default withMedia(DivisionGroup);
export { DivisionGroup as BaseDivisionGroup };